import {
  Input,
  InputGroup,
  InputRightElement,
  Grid,
  Spacer,
  Box,
  GridItem,
} from '@chakra-ui/react';
import { ClearButton } from 'components/atoms/ClearButton';
import { memo, FC } from 'react';

type Props = {
  id: string;
  name: string;
  detail: string;
  handleIdChange: (id: string) => void;
  handleNameChange: (name: string) => void;
  handleDetailChange: (detail: string) => void;
};

export const CustomerListSearchFields: FC<Props> = memo(
  ({
    id,
    name,
    detail,
    handleIdChange,
    handleDetailChange,
    handleNameChange,
  }) => {
    const onIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      handleIdChange(e.target.value);
    };

    const onIdClearClick = () => {
      handleIdChange('');
    };

    const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      handleNameChange(e.target.value);
    };

    const onNameClearClick = () => {
      handleNameChange('');
    };

    const onDetailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      handleDetailChange(e.target.value);
    };

    const onDetailClearClick = () => {
      handleDetailChange('');
    };

    return (
      <Box w="95%" pl="16px" pr="16px">
        <Grid
          templateColumns="1fr 4fr 10fr 15fr"
          gap={0}
          justifyItems="start"
          alignItems="center"
        >
          <GridItem>
            <Spacer />
          </GridItem>
          <GridItem pl="10px">
            <InputGroup size="md">
              <Input
                type="text"
                placeholder="ID"
                value={id}
                onChange={onIdChange}
              />
              <InputRightElement width="4.5rem">
                <ClearButton onClick={onIdClearClick} />
              </InputRightElement>
            </InputGroup>
          </GridItem>
          <GridItem w="100%" pl="10px">
            <InputGroup size="md">
              <Input
                pr="1rem"
                type="text"
                placeholder="顧客名"
                value={name}
                onChange={onNameChange}
              />
              <InputRightElement width="4.5rem">
                <ClearButton onClick={onNameClearClick} />
              </InputRightElement>
            </InputGroup>
          </GridItem>
          <GridItem w="100%" pl="10px">
            <InputGroup size="md">
              <Input
                pr="1rem"
                type="text"
                placeholder="顧客詳細"
                value={detail}
                onChange={onDetailChange}
              />
              <InputRightElement width="4.5rem">
                <ClearButton onClick={onDetailClearClick} />
              </InputRightElement>
            </InputGroup>
          </GridItem>
        </Grid>
      </Box>
    );
  },
);
